<template>
  <a-drawer
    :title=" isAdd ? '新增操作员' : '修改操作员' "
    placement="right"
    :closable="true"
    @ok="handleOkFunc"
    :visible="isShow"
    width="600"
    @close="onClose"
    :maskClosable="false">
    <!-- <a-modal :confirmLoading="confirmLoading"> -->

    <a-form-model
      ref="infoFormModel"
      :model="saveObject"
      :rules="rules"
      style="padding-bottom:50px"
      layout="vertical"
    >
      <a-row justify="space-between" type="flex">
        <a-col :span="10">
          <a-form-model-item label="用户登录名:" prop="loginUsername">
            <a-input v-model="saveObject.loginUsername" :disabled="!isAdd" />
          </a-form-model-item>
        </a-col>

        <a-col :span="10">
          <a-form-model-item label="用户姓名：" prop="realname">
            <a-input v-model="saveObject.realname" />
          </a-form-model-item>
        </a-col>

        <a-col :span="10">
          <a-form-model-item label="手机号：" prop="telphone">
            <a-input v-model="saveObject.telphone" />
          </a-form-model-item>
        </a-col>

        <a-col :span="10">
          <a-form-model-item label="编号：" prop="userNo">
            <a-input v-model="saveObject.userNo" />
          </a-form-model-item>
        </a-col>

        <a-col :span="10">
          <a-form-model-item label="请选择性别：" prop="sex">
            <a-radio-group v-model="saveObject.sex">
              <a-radio :value="1">男</a-radio>
              <a-radio :value="2">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :span="10">
          <a-form-model-item label="状态：" prop="state">
            <a-radio-group v-model="saveObject.state">
              <a-radio :value="1">启用</a-radio>
              <a-radio :value="0">停用</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <!-- 如果有googleVerify,则展示二维码 ，否则不展示 -->
      <a-row justify="space-between" align="middle" type="flex" v-if="googleVerify">
        <a-col :span="14">
          <totp-qrcode
            :key="googleVerify"
            :account-name="saveObject.loginUsername"
            :google-verify="googleVerify"
            label="谷歌验证码"
            :size="200"
            :show-secret="true"
          />
        </a-col>
        <a-col :span="10">
          <a-button type="primary" @click="refreshGoogleVerify" :loading="refreshLoading">
            刷新谷歌验证码
          </a-button>
        </a-col>
      </a-row>
      <a-divider orientation="left" v-if="resetIsShow">
        <a-tag color="#FF4B33">
          账户安全
        </a-tag>
      </a-divider>

      <div style="display:flex;flex-direction:row;">
        <a-row justify="space-between" type="flex" style="width:100%">
          <a-col :span="10">
            <a-form-model-item label="" v-if="resetIsShow">
              重置密码：<a-checkbox v-model="sysPassword.resetPass"></a-checkbox>
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item label="" v-if="sysPassword.resetPass">
              恢复默认密码：<a-checkbox v-model="sysPassword.defaultPass" @click="isResetPass"></a-checkbox>
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>

      <div v-if="sysPassword.resetPass">
        <div v-show="!this.sysPassword.defaultPass">
          <a-row justify="space-between" type="flex">
            <a-col :span="10">
              <a-form-model-item label="新密码：" prop="newPwd">
                <a-input-password
                  autocomplete="new-password"
                  v-model="newPwd"
                  :disabled="sysPassword.defaultPass" />
              </a-form-model-item>
            </a-col>
            <a-col :span="10">
              <a-form-model-item label="确认新密码：" prop="confirmPwd">
                <a-input-password
                  autocomplete="new-password"
                  v-model="sysPassword.confirmPwd"
                  :disabled="sysPassword.defaultPass" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="drawer-btn-center">
        <a-button :style="{ marginRight: '8px' }" @click="onClose" icon="close">取消</a-button>
        <a-button type="primary" @click="handleOkFunc" icon="check" :loading="confirmLoading">保存</a-button>
      </div>

    </a-form-model>
  </a-drawer>
</template>

<script>
	import {
		req,
		API_URL_SYS_USER_LIST,
		updateUserGoogleVerify
	} from '@/api/manage'
	import { Base64 } from 'js-base64'
	import TotpQrcode from '@/components/TotpQrcode/index.vue'

	export default {
		components: {
			TotpQrcode
		},
		props: {
			callbackFunc: {
				type: Function,
				default: () => ({})
			}
		},

		data () {
			return {
				newPwd: '', //  新密码
				resetIsShow: false, // 重置密码是否展现
				sysPassword: {
					resetPass: false, // 重置密码
					defaultPass: true, // 使用默认密码
					confirmPwd: '' //  确认密码
				},
				loading: false, // 按钮上的loading
				value: 1, // 单选框默认的值
				confirmLoading: false, // 显示确定按钮loading图标
				isAdd: true, // 新增 or 修改页面标识
				isShow: false, // 是否显示弹层/抽屉
				saveObject: {}, // 数据对象
				recordId: null, // 更新对象ID
				rules: {
					realname: [{
						required: true,
						message: '请输入用户姓名',
						trigger: 'blur'
					}],
					telphone: [{
						required: true,
						pattern: /\d{10}$/,
						message: '请输入正确的手机号码',
						trigger: 'blur'
					}],
					userNo: [{
						required: true,
						message: '请输入ID',
						trigger: 'blur'
					}],
					loginUsername: [],
					newPwd: [{
						required: false,
						trigger: 'blur'
					}, {
						validator: (rule, value, callBack) => {
							if (!this.sysPassword.defaultPass) {
								if (this.newPwd.length < 6 || this.newPwd.length >
									12) {
									callBack('请输入6-12位新密码')
								}
							}
							callBack()
						}
					}], // 新密码
					confirmPwd: [{
						required: false,
						trigger: 'blur'
					}, {
						validator: (rule, value, callBack) => {
							if (!this.sysPassword.defaultPass) {
								this.newPwd === this.sysPassword.confirmPwd ? callBack()
									: callBack('新密码与确认密码不一致')
							} else {
								callBack()
							}
						}
					}] // 确认新密码
				},
				googleVerify: '', // 谷歌验证码
				refreshLoading: false // 刷新按钮loading状态
			}
		},
		created () {},
		methods: {
			show (recordId) { // 弹层打开事件
				if (this.$refs.infoFormModel !== undefined) {
					this.$refs.infoFormModel.resetFields()
				}

				this.isAdd = !recordId
				// 数据恢复为默认数据
				this.saveObject = {
					state: 1,
					sex: 1,
					googleVerify: '' // 确保有初始值
				}
				this.googleVerify = '' // 重置googleVerify
				this.refreshLoading = false // 重置loading状态
				this.rules.loginUsername = []
				this.confirmLoading = false // 关闭loading

				if (this.isAdd) {
					this.rules.loginUsername.push({
						required: true,
						pattern: /^[a-zA-Z][a-zA-Z0-9]{5,17}$/,
						message: '请输入字母开头，长度为6-18位的登录名',
						trigger: 'blur'
					})
				}

				const that = this
				if (!this.isAdd) { // 修改信息 延迟展示弹层
					that.resetIsShow = true // 展示重置密码板块
					that.recordId = recordId
					req.getById(API_URL_SYS_USER_LIST, recordId).then(res => {
						that.saveObject = res
						that.googleVerify = that.saveObject.googleVerify || ''
					})
					this.isShow = true
				} else {
					that.isShow = true // 立马展示弹层信息
				}
			},
			handleOkFunc: function () { // 点击【确认】按钮事件
				const that = this
				this.$refs.infoFormModel.validate(valid => {
					if (valid) { // 验证通过
						// 请求接口
						that.loading = true // 打开按钮上的 loading
						that.confirmLoading = true // 显示loading
						if (that.isAdd) {
							req.add(API_URL_SYS_USER_LIST, that.saveObject).then(res => {
								that.$message.success('新增成功')
								that.isShow = false
								that.loading = false
								that.callbackFunc() // 刷新列表
							}).catch((res) => {
								that.confirmLoading = false
							})
						} else {
							that.sysPassword.confirmPwd = Base64.encode(that.sysPassword.confirmPwd)
							Object.assign(that.saveObject, that.sysPassword) // 拼接对象
							console.log(that.sysPassword.confirmPwd)
							req.updateById(API_URL_SYS_USER_LIST, that.recordId, that.saveObject).then(res => {
								that.$message.success('修改成功')
								that.isShow = false
								that.callbackFunc() // 刷新列表
								that.resetIsShow = false // 取消展示
								that.sysPassword.resetPass = false
								that.sysPassword.defaultPass = true	// 是否使用默认密码默认为true
								that.resetPassEmpty(that) // 清空密码
							}).catch(res => {
								that.confirmLoading = false
								that.resetIsShow = false // 取消展示
								that.sysPassword.resetPass = false
								that.sysPassword.defaultPass = true	// 是否使用默认密码默认为true
								that.resetPassEmpty(that) // 清空密码
							})
						}
					}
				})
			},
			// 点击遮罩层关闭抽屉
			onClose () {
				this.isShow = false
				this.resetIsShow = false // 取消重置密码板块展示
				this.resetPassEmpty(this) // 清空密码
				this.sysPassword.resetPass = false // 关闭密码输入
				this.sysPassword.defaultPass = true	// 是否使用默认密码默认为true
				this.refreshLoading = false // 重置刷新按钮loading状态
			},
			// 使用默认密码重置是否为true
			isResetPass () {
				if (!this.sysPassword.defaultPass) {
					this.newPwd = ''
					this.sysPassword.confirmPwd = ''
				}
			},
			// 保存后清空密码
			resetPassEmpty (that) {
				that.newPwd = ''
				that.sysPassword.confirmPwd = ''
			},
			async refreshGoogleVerify () {
				this.refreshLoading = true // 开始刷新时设置loading状态
				try {
					const res = await updateUserGoogleVerify(this.recordId)
					console.log('刷新谷歌验证码响应:', res)
					if (res) {
						// 先清空一下，确保能触发更新
						const oldVerify = this.googleVerify
						this.googleVerify = ''
						this.saveObject.googleVerify = ''

						// 使用 $nextTick 确保清空操作完成后再设置新值
						await this.$nextTick()

						// 设置新的验证码
						this.googleVerify = res
						this.saveObject.googleVerify = res
						console.log('GoogleVerify更新:', { from: oldVerify, to: res })
						this.$message.success('谷歌验证码刷新成功')
					} else {
						this.$message.warning('获取到空的验证码')
					}
				} catch (error) {
					console.error('刷新谷歌验证码失败:', error)
					this.$message.error('刷新谷歌验证码失败')
				} finally {
					this.refreshLoading = false // 无论成功还是失败，都重置刷新按钮的loading状态
				}
			}
		}
	}
</script>
